import { render, staticRenderFns } from "./CurriculumView.vue?vue&type=template&id=1af068d5&scoped=true&"
import script from "./CurriculumView.vue?vue&type=script&lang=js&"
export * from "./CurriculumView.vue?vue&type=script&lang=js&"
import style0 from "./CurriculumView.vue?vue&type=style&index=0&id=1af068d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af068d5",
  null
  
)

export default component.exports